import React from 'react';
import "./companiesList.css"
import CompaniesData from './companiesData';

const CompaniesList = (props) => {
    return ( 
        <>
            <div className="mainCompaniesList">
                <h1 className="companiesTitle">Lista firm</h1>
                <CompaniesData 
                    companiesList={props.companiesList}
                    handleDeleteCompany={props.handleDeleteCompany}
                />
            </div>
        </>
     );
}
 
export default CompaniesList;